/* eslint-disable no-underscore-dangle */
import { action, thunk } from 'easy-peasy';

import type { VizSceneStateModel } from './vizScene';

type VizCameraModelSlice = Pick<
  VizSceneStateModel,
  'toggleCameraOrthographicMode' | 'setIsCameraOrthographic'
>;

export const vizCameraModel: VizCameraModelSlice = {
  toggleCameraOrthographicMode: thunk((actions, _, { getState }) => {
    const wasCameraOrthographic =
      getState().pointCloudGlobalSettings.isOrthographicCamera;

    actions.updatePointCloudGlobalSettings({
      isOrthographicCamera: !wasCameraOrthographic,
    });

    return !wasCameraOrthographic;
  }),

  setIsCameraOrthographic: action((state, isOrthographic) => {
    state.pointCloudGlobalSettings.isOrthographicCamera = isOrthographic;
  }),
};
